import { Campaign } from 'entities/campaign';
import { EntityWithId } from 'services/apiGatewayClient/interface';
import { MpsCampaignResponse } from '../types';
import { normalizeMpsAudit } from './normalizeMpsAudit';

/**
 * Maps MPS campaign API response (Go wrapped shape) to app entity.
 * The Go API mirrors the Kotlin shape: { id, value: { name, ... }, audit, parentResourceIds }.
 */
export function mapMpsCampaignResponseToEntity(item: MpsCampaignResponse): EntityWithId<Campaign> {
  const value = item.value ?? {};
  return {
    id: item.id,
    entity: {
      id: item.id,
      name: value.name,
      objective: value.objective as Campaign['objective'],
      type: value.type as Campaign['type'],
      state: value.state as Campaign['state'],
      startTime: value.startTime,
      endTime: value.endTime,
      startDate: value.startTime,
      endDate: value.endTime,
      rulesetPriorities: value.rulesetPriorities,
      audit: normalizeMpsAudit(item.audit),
    },
  };
}
